import React, { useMemo } from 'react';
import { Page as BasePage, PageProps } from '@hud/web-components/Layout/Page';
import { useGlobalQueryString } from '../../hooks/useGlobalFilter';
import ExtensionBannerRenderer from '../ExtensionBanner/ExtensionBannerRenderer';

export default function Page({ header, ...props }: PageProps) {
  const globalFilters = useGlobalQueryString();
  const normalizedHeader = useMemo(() => {
    if (header === 'loading') {
      return 'loading';
    }
    if (Array.isArray(header)) {
      return header.map((item) => {
        if (item.to) {
          // if to includes ? we add global filters with &
          if (item.to.includes('?')) {
            return {
              ...item,
              to: `${item.to}&${globalFilters}`,
            };
          }
          return {
            ...item,
            to: `${item.to}?${globalFilters}`,
          };
        }
        return item;
      });
    }
    return header;
  }, [globalFilters, header]);


  return <BasePage
    {...props}
    banner={<ExtensionBannerRenderer />}
    header={normalizedHeader} />;
}
